import { IQuiz } from '@quizzach/interfaces';
import { consoleDev, ConsoleStatus, fetchData } from '@quizzach/utils';
import { useAuth } from '@quizzach/contexts';
import { useState } from 'react';
import i18n from '@quizzach/i18n';

export const useVoucher = () => {
	const { refreshProfile } = useAuth();
	const [code, setCode] = useState('');
	const [loading, setLoading] = useState<boolean>(false);
	const [error, setError] = useState<boolean>(false);
	const [errorMessage, setErrorMessage] = useState<string>('');
	const [quiz, setQuiz] = useState<IQuiz>(new IQuiz());

	const handleSubmit = async (e: React.FormEvent) => {
		e.preventDefault();
		setLoading(true);
		try {
			const cleanCode = code.replace(/\s+/g, '').toUpperCase();

			const response = await fetchData<IQuiz>(
				`/api/voucher/${cleanCode}`,
				{
					method: 'GET',
				},
				{
					authRoute: true,
				}
			);
			if (response.status >= 300) {
				consoleDev('voucher', ConsoleStatus.HTTP, response.status);
				setError(true);

				switch (response.status) {
					case 404:
						setErrorMessage(i18n.t('error.voucher.notFound'));
						break;
					case 403:
						setErrorMessage(i18n.t('error.voucher.alreadyUsed'));
						break;
					case 400:
						setErrorMessage(i18n.t('error.voucher.alreadyOwned'));
						break;
					default:
						setErrorMessage(i18n.t('error.voucher.generic'));
				}
			}

			// error responses carry a JSON body too — storing it as the quiz
			// would leave uuid-less junk in state
			if (response.status < 300 && response.data) {
				consoleDev('voucher', ConsoleStatus.SUCC);
				setQuiz(response.data);
				// The redeemed code now counts as used — refresh the profile so
				// voucher-gated UI (e.g. the gratis block) updates immediately.
				refreshProfile();
			}
		} catch (err) {
			consoleDev('voucher', ConsoleStatus.NET, err);
			setError(true);
		} finally {
			setLoading(false);
		}
	};

	const handleInputChange = (value: string) => {
		setCode(value);
	};

	return {
		code,
		loading,
		error,
		quiz,
		errorMessage,
		setError,
		handleInputChange,
		handleSubmit,
		setCode,
	};
};
